import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Garrett Guillotte --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Audit logs";
const frontMatter = {
  "title": "Audit logs"
};
import {Icon} from '@/components';
import {mdiShieldAccount, mdiWrench} from '@mdi/js';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    h1: "h1",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Audit logs"}</_components.h1>{"\n"}<_components.p>{"To view recent system and user actions, view the Audit Log, which is available\nto users with administrative privileges. In the navigation menu, click\n"}<_components.strong><Icon path={mdiShieldAccount} />{" Go to Admin"}</_components.strong>{" and then select\n"}<_components.strong><Icon path={mdiWrench} />{" Platform "}<span aria-label="and then">{">"}</span>{" Audit logs"}</_components.strong>{"."}</_components.p>{"\n"}<_components.p>{"Click one of the listed actions or events to view its details, including the\nfollowing:"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li>{"Description of the event."}</_components.li>{"\n"}<_components.li>{"Date and time of the event."}</_components.li>{"\n"}<_components.li>{"Service account ID of the user who performed the event."}</_components.li>{"\n"}<_components.li>{"App that generated the event."}</_components.li>{"\n"}<_components.li>{"App method that generated the event"}</_components.li>{"\n"}<_components.li>{"Method resource that generated the event."}</_components.li>{"\n"}<_components.li>{"Full JSON payload of the event."}</_components.li>{"\n"}</_components.ul></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/administer/audit-logs',
  {"filePath":"pages/administer/audit-logs.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)